import { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';

import {
  TXTCLI_You_can_collect_your_bonus_in__ELL,
  TXTCLI_Your_deposit_also_qualifies_yo_ELL
} from './SpellCashPortionRelease.messages.json';

interface Props {
  bonusFormatted: number | JSX.Element;
}

const SpellCashPortionRelease: React.FC<Props> = ({ bonusFormatted }) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { bonusCurrency, fppReleasePortion, releasePortion } = preCashinInfo as PreCashinInfo;

  return (
    <>
      <Translation
        tagName="p"
        {...TXTCLI_Your_deposit_also_qualifies_yo_ELL}
        values={{
          0: bonusFormatted
        }}
      />
      <Translation
        tagName="p"
        {...TXTCLI_You_can_collect_your_bonus_in__ELL}
        values={{
          // @ts-expect-error - Type issue was not resolved prior to TS5 upgrade.
          0: <CurrencyAmount value={releasePortion} currency={Currency[bonusCurrency]} />,
          1: fppReleasePortion
        }}
      />
    </>
  );
};

export default SpellCashPortionRelease;
